const { mapState } = require('vuex')
const { HEALTH_TRACKER } = require('../../common/constants/roles')
const { PS } = require( '../../common/constants/roles')
const backend_path = process.env.VUE_APP_URL_API

module.exports = {
    computed: {
        // get current day
        get_today () {
            return this.get_year+'-'+(this.get_mont)+'-'+this.get_day
        },
        /***
         * Obtener el dia
         **/
        get_day() {
            return (new Date().getDate())
        },
        /***
         * Obtener el año
         **/
        get_year () {
            return (new Date().getFullYear())
        },
        // get current mont
        get_mont () {
            return (new Date().getMonth()+1)
        }
        /*
            Obtener la fecha sin transformacion
         */
        , getDate () {
            return new Date()
        }
        /***
         * mostrar pop ups una sola vez al dia
         ***/
        , show_pop_ups () {
            this.valid_pop_ups()
            const storage = JSON.parse(localStorage.getItem('pop_ups_' + this.user.id))
            return storage.show
        },
        /***
         * Retorna la lista de roles de HT
         **/
        HTRoleList () {
            return HEALTH_TRACKER
        },
        /***
         * Formato de humano para moment
        */
        getHumanDate() {
            return 'DD/MM/YYYY'
        },
        /***
         * Formato de humano que incluye hour para moment
        */
        getHumanDateWithHour () {
            return 'DD/MM/YYYY hh:mm:ss:A'
        },
        /*
         ** Lista de colores
        */
        COLORS() {
            return {
                OUTLINE_PRIMARY: '#ECECFF',
                PRIMARY: '#7A7CFF'
            }
        },
        /*
         ** Retorna el mensaje en la tabla si no existen los datos
        */
        tableNoDataMessage () {
            return '¡Lo sentimos!, no se encontro información.'
        },
        /***
         * Obtener la ubicacion actual del usuario loqueado
         **/
        currentUserLocation() {
            const { site } = this.userData
            return site ? site.name + ' - ' + site.city.name||null : null
        },
        /**
         * Roles de Permisos sindicales
         */
        PS_ROLES() {
         return PS
        },
        /***
         * Obtener el usuaruario logueqado
         **/
        ...mapState('modCore', [
            'user'
            , 'userData'
            ]
        )
        /*
            validad n cantidad de modulos que sean pasados
         */
        , validModule () {
            return (...modules) => {
                return this.userData ? modules.includes(this.userData.core_role ? this.userData.core_role.module :  null) : false
            }
        }
        /*
           obtener atributo del usuario en session
         */
        , getAttributeUserData () {
            return (key) => {
                return this.userData ? this.userData[key] : false
            }
        }
        , backendPath () {
            return backend_path||'null';
        }
        /*
           retorna las columnas de un array
         */
        , arrayColumn () {
            return (array, column) => {
                return array.map(item => item[column])
            }
        }
        /*
         lo conviente en objectos simples
         */
        , arrayFlat () {
            return (array) => {
                return array.flat()
            }
        }
        // #rol del usuario en session
        , gerRoleOfCurrentUser () {
            return this.user && this.user.core_role_name ? this.user.core_role_name : ''
        }
        // ## devuelve el codigo del rol del usuario en session en caaso de existir
        , getCodeRoleCurrentUser () {
            return this.user && this.user.core_role_code ? this.user.core_role_code : ''
        }
        // # aplica saltos de linea para cada \n que encuentre
        , formattedTextLineBreak() {
            return (text = '') => {
                return text.replace(/\\n/g, '<br>')
            }
        }
        //## SEPARAR VALORES DESPUES DEL PARAMETRO QUE SE LE ENVIE
        , separateValues () {
            return (values, separeTo = 3) => [...String(values)].reduce((value, count, iteration) => value += (iteration && !(iteration % separeTo)) ? "." + count : count, "")
        }
        //## CONVIENTE TODO A MONEDA LOCAL 
        , parseToMoney () {
            return (value) => new Intl.NumberFormat('es-CO'
            , {
                currency: 'COP'
                , minimumFractionDigits: 0
            }).format(
                value
            )
        }
    },
    methods: {
        // Genera Str random
         randomSTR: (long = 40) => {
             const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
             let result = ''
             for (let i = 0; i < long; i++) {
                 const index = Math.floor(Math.random() * characters.length)
                 result += characters.charAt(index)
             }
             return result
        }
        // coloca la primera letra en mayúscula
        , capitalizeFirstLetter(str) {
             const value = str.toLowerCase()
             return value.charAt(0).toUpperCase().concat(value.slice(1))
        }
        // show modal of x name
        , showModal (name = '') {
            this.$refs[name].show()
        },
        // hide modal of x name
        hideModal (name = '') {
            this.$refs[name].hide()
        },
        // toggle modal of x name
        toggleModal (name = '', id_button = '') {
            this.$refs[name].toggle(`#${id_button}`)
        },
        // get name mont when parse key (1-12)
        get_mont_name(key= 0) {
            const values = {
                1: 'Enero',
                2: 'Febrero',
                3: 'Marzo',
                4: 'Abril',
                5: 'Mayo',
                6: 'Junio',
                7: 'Julio',
                8: 'Agosto',
                9: 'Septiembre',
                10: 'Octubre',
                11: 'Noviembre',
                12: 'Diciembre'
            }
            if (values[key]) return values[key]
            return '¡Lo sentemos!, mala información'
        },
        /***
         * Validar si el usuario logueado tiene el rol separados por |
         ***/
        can(id_roles = '|') {
            const roles = id_roles.split('|')
            return roles.includes(this.user.core_role_id.toString())
        },
        /***
         * Validar si el usuario logueado tiene el rol separados por |
         ***/
        canWithCode(...codes) {
            return codes.includes(this.user.core_role_code)
        },
        /**
         * VALIDAR EL ROL CON EL NOMBRE QUE SE INGRESA
         **/
        is_role(code = '') {
            return (this.user.core_role_code) ? code === this.user.core_role_code : false
        },
        /***
         * obtener la diferencia de fecha
         ***/
        get_date_difference (started_date = '', end_date = '', type = 'days') {
            const started = started_date ? new Date(started_date) : new Date()
            const end = end_date ? new Date(end_date) : started
            const values = {
                days: this.difference_day,
                months: this.difference_months,
                hours: this.difference_hours
            }
            if (values[type]) {
                return values[type](started, end)
            }
            return '¡Lo siento!, el tipo de diferencia aun no es soportada'
        },
        /***
         * retorna la diferencia de las hora entre fechas
         ***/
        difference_hours (started_date = new Date(), end_date= new Date()) {
            let difference = (started_date.getTime() - end_date.getTime()) / 1000
            difference /= (60 * 60)
            return Math.abs(Math.round(difference))
        },
        /***
         * retorna los dias
         ***/
        difference_day(started_date = new Date(), end_date= new Date()) {
            const difference = Math.abs(started_date.getTime() - end_date.getTime())
            return Math.ceil(difference/(1000 * 3600 * 24))
        },
        /***
         * retorna los meses
         ***/
        difference_months(started_date= new Date(), end_date= new Date()) {
            return Math.abs((started_date.getFullYear() - end_date.getFullYear()) * 12)
        },
        /***
         * valida si el pop ups fue mostrado el dia actual, de ser asi no debe mostrarse
         ***/
        valid_pop_ups() {
            const key = 'pop_ups_' + this.user.id
            if(localStorage.getItem(key)) {
                const storage = JSON.parse(localStorage.getItem(key))
                if (this.get_today <= storage.last_time) {
                    if (storage.views !== 0 || storage.views === 0) {
                        return localStorage.setItem(key, JSON.stringify({
                            last_time: this.get_today,
                            views: 0,
                            show: false
                        }))
                    }
                }
                if (this.get_today > storage.last_time) {
                    return localStorage.setItem(key, JSON.stringify({
                        last_time: this.get_today,
                        views: 1,
                        show: true
                    }))
                }
            } else {
                return localStorage.setItem(key, JSON.stringify({
                    last_time: this.get_today,
                    views: 1,
                    show: true
                }))
            }
        },
        /***
         * Valida si exite en la lista de roles que recibe
         ***/
        roleCan(...roles) {
            return (this.user.core_role_id) ? roles.includes(this.user.core_role_id) : false
        },
        /**
         * Cortar string 
        */
        cutText(text = '', cutIn = 1) {
            if (text.length > cutIn) {
                return text.substr(0, cutIn).concat('...')
            }
            return text
        },
        /**
         * Aplicar estilos a x elemento 
        */
        applyStyles (element, keys = {}) {
            Object.entries(keys).forEach(entry  => {
                const [ key, value ] = entry 
                element[key] = value
            });
        },
        /***
         * Eliminar estilos de las tablas b-table
         **/
        forgetTableStyleById (idTable = 'b-table') {
            const tableSelected = document.getElementById(idTable)
            if (tableSelected != null) {
                this.$nextTick(() => {           
                    tableSelected.classList.forEach(element => {
                        tableSelected.classList.remove(element)
                    })
                    tableSelected.classList.add('col-12')
                })
            }
        },
        /**
         *  Mapea texto | primera en mayuscula y el resto a minuscula
         */
        mapperText (text = 'palabra que quiere mappear') {
            const array = text.split(' ')
            return array.map((palabra) => { 
                return palabra[0].toUpperCase().concat(palabra.slice(1).toLowerCase())
            }).join(' ')
        }

        /*
         * Convierta a mayuscula las primeras letras del text
         */
        , capitalizeText (text = 'string para formatear') {
            if (
                typeof text == 'string'
            ) {
                text = text.toLowerCase()
                const array = text.split(' ')
                array.forEach((value, index) => {
                    array[index] = array[index].charAt(0).toUpperCase() + array[index].slice(1)
                })
                return array.join(' ')
            }
            return '¡No es una cadena de texto!'
        }

        /**
         * Mapea el texto a la cantidad necesaria
         * @param text
         * @param length
         * @param initial
         * @returns {string}
         */
        , mapSizeText(text = 'text', length = 2, initial = 0) {
            return text ? text.slice(initial,length) : null
        }
        , getFileSize (size = 0) {
            const units = ['bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
            let l = 0, n = parseInt(size, 10) || 0
            while (n >= 1024 && ++l) { n = n/1024 }
            return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l])
        }
        // ## VALIDA QUE DOS ELEMENTOS SEAN DIFERENTES EN AL MENOS UNA CLAVE - VALOR DE LOS OBJETOS
        // ## INDISTITAMENTE DEL ORDER
        , validObjects(objectOne = {}, objectTwo = {}) {
            const keysOne = Object.keys(objectOne)
            const keysTwo = Object.keys(objectTwo)
            return (
                keysOne.some(clave => !objectTwo[clave] || objectTwo[clave] !== objectOne[clave]) ||
                keysTwo.some(clave => !objectOne[clave] || objectOne[clave] !== objectTwo[clave])
            )
        }
    }
}